<template>
  <v-card class="border-radius pa-2">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form_position"
      @keydown.esc="dialog.form_position = false"
      :fullscreen="dialog.fullscreen"
      width="550"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Tambah Posisi

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form_position = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form_position">
            <v-form>
              <ValidationProvider 
                name="Unit" 
                rules="required"
                v-slot="{ errors, valid }">
                <p class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Unit
                  <span class="error--text">
                    wajib diisi
                  </span>
                </p>

                <v-select
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  :item-color="set_color"
                  placeholder="Contoh. Kantor Pusat SDM"
                  :items="list_unit"
                  item-value="value"
                  item-text="text"
                  v-model="form_position.unit_id"

                  :success="form_position.unit_id !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; max-width: 60%;">
                  <template slot="selection" slot-scope="data">
                    <span class="text-capitalize">
                      {{ data.item.text }}
                    </span>
                  </template>

                  <template slot="item" slot-scope="data">
                    <span class="text-capitalize">
                      {{ data.item.text }}
                    </span>
                  </template>
                  
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Unit {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form_position.unit_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="Posisi Diatasnya" 
                rules="required"
                v-slot="{ errors, valid }">
                <p class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Posisi Diatasnya
                  <span class="error--text">
                    wajib diisi
                  </span>
                </p>

                <v-select
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  :item-color="set_color"
                  placeholder="Contoh. Developer"
                  :items="list_position"
                  item-value="value"
                  item-text="text"
                  v-model="form_position.par_id"

                  :success="form_position.par_id !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; max-width: 70%;">
                  <template slot="selection" slot-scope="data">
                    <span class="text-capitalize">
                      {{ data.item.text }}
                    </span>
                  </template>

                  <template slot="item" slot-scope="data">
                    <span class="text-capitalize">
                      {{ data.item.text }}
                    </span>
                  </template>
                  
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Posisi Diatasnya {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form_position.par_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="Posisi" 
                rules="required"
                v-slot="{ errors, valid }">
                <p class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Posisi
                  <span class="error--text">
                    wajib diisi
                  </span>
                </p>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Programmer"
                  v-model="form_position.title"
                  vvvv-uppercase
                  :success="form_position.title !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; max-width: 70%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Posisi {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form_position.title !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="Deskripsi" 
                v-slot="{ errors, valid }">
                <p class="body-2 mb-2">
                  Deskripsi
                  <span>
                    (boleh dikosongi)
                  </span>
                </p>

                <v-textarea
                  filled
                  rounded
                  dense
                  rows="3"
                  hide-details
                  :color="set_color"
                  placeholder="Contoh. Bergelut dalam pengkodean aplikasi"
                  v-model="form_position.job_desc"
                  vvvv-uppercase
                  :success="form_position.job_desc !== '' && valid"
                  :error-messages="errors"
                  class="mb-3"
                  style="border-radius: 10px;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Deskripsi {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form_position.job_desc !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-textarea>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form_position"
            :loading="process.form_position"
            v-on:keyup.enter="save_position()"
            @click="save_position()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form_position"
            @click="dialog.form_position = false; reset_position();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
      {{ Object.keys(detail).length > 0 ? 'Ubah' : 'Tambah' }}

      <v-spacer/>

      <v-icon 
        @click="$emit('screen', !fullscreen ? true : false)"
        class="cursor-pointer mr-1"
        size="24"
        :color="set_color">
        {{ !fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
      </v-icon>

      <v-icon 
        @click="reset()"
        class="cursor-pointer"
        size="24"
        color="red">
        mdi-close-circle-outline
      </v-icon>
    </v-card-title>

    <v-divider class="mx-4 mt-3 mb-2"/>

    <v-card-text class="pt-2" :style="form.length > 10 ? 'height: 750px' : ''">
      <ValidationObserver ref="form">
        <v-form>
          <v-row v-for="(item, index) in form" :key="index">
            <!-- ID -->
            <v-text-field v-if="item.hide"
              style="display: none; border-radius: 10px;"
              filled
              rounded
              dense
              :color="set_color"
              hide-details
              v-model="item.value"
              vvvv-uppercase>
            </v-text-field>
            
            <v-col v-if="item.type !== 'column' && item.type !== 'id' && !item.hide">
              <div v-if="item.type === 'check'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    :style="`max-width: ${item.width};`"
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    :type="item.type"
                    :placeholder="item.placeholder"
                    v-model="item.value"
                    vvvv-uppercase

                    @blur="fetchCheck(item.value, index)"

                    :success="item.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && check.index === index && check.error.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ check.error }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid && check.index !== index && check.error.length < 1">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'text' || item.type === 'number'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    :style="`max-width: ${item.width};`"
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    :type="item.type"
                    :placeholder="item.placeholder"
                    v-model="item.value"
                    vvvv-uppercase
                    :success="item.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'password'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    :style="`max-width: ${item.width};`"
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    :type="show ? 'text' : 'password'"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :placeholder="item.placeholder"
                    @click:append="show = !show"
                    v-model="item.value"
                    vvvv-uppercase
                    :success="item.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'select'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-select
                    :style="`max-width: ${item.width};`"
                    filled
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    :item-color="set_color"
                    :placeholder="item.placeholder"
                    :items="item.option"
                    item-value="value"
                    item-text="text"
                    v-model="item.value"

                    @change="selected(item)"

                    :success="item.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template slot="selection" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>

                    <template slot="item" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>
                    
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'select_unit'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-select
                    :style="`max-width: ${item.width};`"
                    filled
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    :item-color="set_color"
                    :placeholder="item.placeholder"
                    :items="item.option"
                    item-value="value"
                    item-text="text"
                    v-model="item.value"

                    @change="form_position.unit_id = item.value"

                    :success="item.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template slot="selection" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>

                    <template slot="item" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>
                    
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'select_add'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <div
                    class="d-flex align-center">
                    <v-select
                      :style="`max-width: ${item.width};`"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details
                      :color="set_color"
                      :item-color="set_color"
                      :placeholder="item.placeholder"
                      :items="list_position"
                      item-value="value"
                      item-text="text"
                      v-model="item.value"

                      @change="selected(item)"

                      :success="item.value !== '' && valid"
                      :error-messages="errors"
                      style="border-radius: 10px;">
                      <template slot="selection" slot-scope="data">
                        <span class="text-capitalize">
                          {{ data.item.text }}
                        </span>
                      </template>

                      <template slot="item" slot-scope="data">
                        <span class="text-capitalize">
                          {{ data.item.text }}
                        </span>
                      </template>
                      
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ item.label }} {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="item.value !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>

                    <v-btn
                      @click="dialog.form_position = true; reset_position();"
                      min-width="36"
                      height="36"
                      elevation="0"
                      class="px-0 ml-4"
                      style="border-radius: 10px;">
                      <v-icon>
                        mdi-plus
                      </v-icon>
                    </v-btn>

                    <!-- <v-btn
                      @click="fetchPosition()"
                      min-width="36"
                      height="36"
                      elevation="0"
                      class="px-0 ml-4"
                      style="border-radius: 10px;">
                      <v-icon>
                        mdi-reload
                      </v-icon>
                    </v-btn> -->
                  </div>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'select_sub'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    style="display: none;"
                    v-model="item.value"
                    :success="item.value !== '' && valid"
                    :error-messages="errors">
                  </v-text-field>

                  <v-menu
                    v-model="select_sub"
                    :close-on-content-click="false"
                    offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        
                        :style="`max-width: ${item.width};`"

                        filled
                        rounded
                        dense
                        :color="set_color"

                        readonly

                        append-icon="mdi-menu-down"
                        :placeholder="item.placeholder"

                        hide-details

                        v-model="select_title"

                        :success="item.value !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ item.label }} {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="item.value !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </template>

                    <v-list 
                      flat 
                      dense 
                      max-height="300"
                      style="overflow-y: auto;">
                      <div 
                        v-for="(item_par, index_par) in item.option"
                        :key="index_par">
                        <v-list-item 
                          v-if="item_par.children.length < 1"
                          color="transparent">
                          <v-list-item-content>
                            <v-list-item-title
                              class="body-2">
                              {{ item_par.name }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <div v-else>
                          <v-list-group
                            :color="set_color"
                            :append-icon="item_par.children.length > 0 ? 'mdi-menu-down' : ''"
                            no-action>
                            <template v-slot:activator>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="body-2 d-flex align-center">
                                  <v-icon size="18">mdi-folder-outline</v-icon>

                                  <span
                                    class="ml-2">
                                    {{ item_par.name }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>

                            <div
                              v-for="(item_sub, index_sub) in item_par.children"
                              :key="index_sub">
                              <v-list-item
                                @click="item.value = item_sub.id; select_title = item_sub.name; select_sub = false;"
                                color="transparent"
                                style="padding-left: 42px;">
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="body-2"
                                    :style="`color: ${item.value === item_sub.id ? set_color : ''};`">
                                    {{ item_sub.name }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </div>
                          </v-list-group>
                        </div>
                      </div>
                    </v-list>
                  </v-menu>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'select_icon'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-select
                    :style="`max-width: ${item.width};`"
                    filled
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    :item-color="set_color"
                    :placeholder="item.placeholder"
                    :items="item.option"
                    item-value="value"
                    item-text="text"
                    v-model="item.value"

                    @change="selected(item)"

                    :success="item.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template slot="selection" slot-scope="data">
                      <div
                        class="d-flex align-center">
                        <v-img 
                          contain
                          width="30"
                          height="auto"
                          alt="amanata" 
                          :src="data.item.icon"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="white">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <span class="text-capitalize ml-3">
                          {{ data.item.text }}
                        </span>
                      </div>
                    </template>

                    <template slot="item" slot-scope="data">
                      <div
                        class="d-flex align-center">
                        <v-img 
                          contain
                          width="30"
                          height="auto"
                          alt="amanata" 
                          :src="data.item.icon"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="white">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>

                        <span class="text-capitalize ml-3">
                          {{ data.item.text }}
                        </span>
                      </div>
                    </template>
                    
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'radio'">
                <p class="body-2 mb-2">
                  {{ item.label }}
                </p>

                <v-radio-group
                  class="mt-0"
                  v-model="item.value"
                  row
                  hide-details>
                  <v-radio v-for="(radio, i) in item.option" :key="i"
                    :label="radio.text"
                    :color="set_color"
                    :value="radio.value">
                  </v-radio>
                </v-radio-group>
              </div>

              <div v-if="item.type === 'date'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="item.required">*</span>
                  {{ item.label }}
                  <span :class="item.required ? 'error--text' : ''">
                    ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <v-menu
                  :ref="`date${index}`"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="item.picker">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      :name="item.label" 
                      :rules="item.rules"
                      v-slot="{ errors, valid }">
                        <v-text-field
                          :style="`max-width: ${item.width};`"
                          v-model="item.value"
                          vvvv-uppercase
                          readonly
                          filled
                          rounded
                          dense
                          :color="set_color"
                          :placeholder="item.placeholder"
                          hide-details
                          clearable
                          @click:clear="item.value = ''"
                          v-on="on"
                          v-bind="attrs"
                          :success="item.value !== '' && valid"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ item.label }} {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="item.value !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="item.value"
                    @input="item.picker = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <div v-if="item.type === 'time'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="item.required">*</span>
                  {{ item.label }}
                  <span :class="item.required ? 'error--text' : ''">
                    ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <v-menu
                  ref="time"
                  v-model="item.time"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="item.value"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      :name="item.label" 
                      :rules="item.rules"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        :style="`max-width: ${item.width};`"
                        v-model="item.value"
                        vvvv-uppercase
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        :placeholder="item.placeholder"
                        hide-details
                        clearable
                        @click:clear="item.value = ''"
                        v-on="on"
                        v-bind="attrs"
                        :success="item.value !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ item.label }} {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="item.value !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-time-picker
                    v-if="item.time"
                    v-model="item.value"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.time[index].save(item.value)">
                  </v-time-picker>
                </v-menu>
              </div>

              <div v-if="item.type === 'textarea'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-textarea
                    :style="`max-width: ${item.width};`"
                    filled
                    rounded
                    dense
                    :rows="item.rows"
                    hide-details
                    :color="set_color"
                    :type="item.type"
                    :placeholder="item.placeholder"
                    v-model="item.value"
                    vvvv-uppercase
                    :success="item.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'texteditor'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="item.required">*</span>
                  {{ item.label }}
                  <span :class="item.required ? 'error--text' : ''">
                    ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>
                
                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: item.placeholder
                  }"
                  v-model="item.value">
                </quill-editor>
              </div>

              <div v-if="item.type === 'image'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="item.required">*</span>
                  {{ item.label }}
                  <span :class="item.required ? 'error--text' : ''">
                    ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <uploadfolder v-model="images">
                  <div slot="activator">
                    <v-card
                      outlined
                      class="d-flex align-center justify-center cursor-pointer"
                      :width="item.full === undefined ? 175 : '100%'"
                      :height="item.full === undefined ? 175 : 250"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <v-avatar v-if="!process.image"
                        v-ripple
                        tile 
                        :width="item.full === undefined ? 173 : '100%'"
                        :height="item.full === undefined ? 173 : 250"
                        class="cursor-pointer">
                        <v-img 
                          v-if="item.value.length > 0"
                          contain
                          :width="item.full === undefined ? 173 : '100%'"
                          :height="item.full === undefined ? 173 : 250"
                          alt="vuetify"
                          :src="item.value">
                        </v-img>

                        <v-icon v-else size="50" color="grey">mdi-cloud-upload-outline</v-icon>
                      </v-avatar>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>
            </v-col>

            <v-col v-show="item.type === 'column' && item.type !== 'id' && !item.hide"
              v-for="(subItem, key) in item.sub" :key="key"
              :cols="subItem.col">
              <div v-if="subItem.type === 'text' || subItem.type === 'number'">
                <ValidationProvider 
                  :name="subItem.label" 
                  :rules="subItem.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="subItem.required">*</span>
                    {{ subItem.label }}
                    <span :class="subItem.required ? 'error--text' : ''">
                      ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    :style="`max-width: ${subItem.width};`"
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    :type="subItem.type"
                    :placeholder="subItem.placeholder"
                    v-model="subItem.value"
                    vvvv-uppercase
                    :success="subItem.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ subItem.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="subItem.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>
              
              <div v-if="subItem.type === 'password'">
                <ValidationProvider 
                  :name="subItem.label" 
                  :rules="subItem.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="subItem.required">*</span>
                    {{ subItem.label }}
                    <span :class="subItem.required ? 'error--text' : ''">
                      ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    :style="`max-width: ${subItem.width};`"
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    :type="show ? 'text' : 'password'"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :placeholder="subItem.placeholder"
                    v-model="subItem.value"
                    vvvv-uppercase
                    :success="subItem.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ subItem.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="subItem.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="subItem.type === 'select'">
                <ValidationProvider 
                  :name="subItem.label" 
                  :rules="subItem.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="subItem.required">*</span>
                    {{ subItem.label }}
                    <span :class="subItem.required ? 'error--text' : ''">
                      ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-select
                    :style="`max-width: ${subItem.width};`"
                    filled
                    rounded
                    dense
                    single-line
                    hide-details
                    :color="set_color"
                    :item-color="set_color"
                    :placeholder="subItem.placeholder"
                    :items="subItem.option"
                    item-value="value"
                    item-text="text"
                    v-model="subItem.value"

                    @change="selected(subItem)"

                    :success="subItem.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template slot="selection" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>

                    <template slot="item" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>
                    
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ subItem.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="subItem.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div v-if="subItem.type === 'radio'">
                <p class="body-2 mb-2">
                  {{ subItem.label }}
                </p>

                <v-radio-group
                  class="mt-0"
                  v-model="subItem.value"
                  row
                  hide-details>
                  <v-radio v-for="(radio, i) in subItem.option" :key="i"
                    :label="radio.text"
                    :color="set_color"
                    :value="radio.value">
                  </v-radio>
                </v-radio-group>
              </div>

              <div v-if="subItem.type === 'date'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="subItem.required">*</span>
                  {{ subItem.label }}
                  <span :class="subItem.required ? 'error--text' : ''">
                    ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <v-menu
                  :ref="`subdate${key}`"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="subItem.picker">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      :name="subItem.label" 
                      :rules="subItem.rules"
                      v-slot="{ errors, valid }">
                        <v-text-field
                          :style="`max-width: ${subItem.width};`"
                          v-model="subItem.value"
                          vvvv-uppercase
                          readonly
                          filled
                          rounded
                          dense
                          :color="set_color"
                          :placeholder="subItem.placeholder"
                          hide-details
                          clearable
                          @click:clear="subItem.value = ''"
                          v-on="on"
                          v-bind="attrs"
                          :success="subItem.value !== '' && valid"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ subItem.label }} {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="subItem.value !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="subItem.value"
                    @input="subItem.picker = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <div v-if="subItem.type === 'time'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="subItem.required">*</span>
                  {{ subItem.label }}
                  <span :class="subItem.required ? 'error--text' : ''">
                    ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <v-menu
                  ref="time"
                  v-model="subItem.time"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="subItem.value"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      :name="subItem.label" 
                      :rules="subItem.rules"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        :style="`max-width: ${subItem.width};`"
                        v-model="subItem.value"
                        vvvv-uppercase
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        :placeholder="subItem.placeholder"
                        hide-details
                        clearable
                        @click:clear="subItem.value = ''"
                        v-on="on"
                        v-bind="attrs"
                        :success="subItem.value !== '' && valid"
                        :error-messages="errors"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ subItem.label }} {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="subItem.value !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-time-picker
                    v-if="subItem.time"
                    v-model="subItem.value"
                    full-width
                    :color="set_color"
                    format="24hr"
                    @click:minute="$refs.time[key].save(subItem.value)">
                  </v-time-picker>
                </v-menu>
              </div>

              <div v-if="subItem.type === 'textarea'">
                <ValidationProvider 
                  :name="subItem.label" 
                  :rules="subItem.rules"
                  v-slot="{ errors, valid }">
                  <p class="body-2 mb-2">
                    <span class="red--text" v-if="subItem.required">*</span>
                    {{ subItem.label }}
                    <span :class="subItem.required ? 'error--text' : ''">
                      ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-textarea
                    :style="`max-width: ${subItem.width};`"
                    filled
                    rounded
                    dense
                    :rows="subItem.rows"
                    hide-details
                    :color="set_color"
                    :type="subItem.type"
                    :placeholder="subItem.placeholder"
                    v-model="subItem.value"
                    vvvv-uppercase
                    :success="subItem.value !== '' && valid"
                    :error-messages="errors"
                    style="border-radius: 10px;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ subItem.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="subItem.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </div>

              <div v-if="subItem.type === 'texteditor'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="subItem.required">*</span>
                  {{ subItem.label }}
                  <span :class="subItem.required ? 'error--text' : ''">
                    ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>
                
                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: subItem.placeholder
                  }"
                  v-model="subItem.value">
                </quill-editor>
              </div>

              <div v-if="subItem.type === 'image'">
                <p class="body-2 mb-2">
                  <span class="red--text" v-if="subItem.required">*</span>
                  {{ subItem.label }}
                  <span :class="subItem.required ? 'error--text' : ''">
                    ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <uploadfolder v-model="images">
                  <div slot="activator">
                    <v-card
                      outlined
                      class="d-flex align-center justify-center cursor-pointer"
                      :width="subItem.full === undefined ? 175 : '100%'"
                      :height="subItem.full === undefined ? 175 : 250"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <v-avatar v-if="!process.image"
                        v-ripple
                        tile 
                        :width="subItem.full === undefined ? 173 : '100%'"
                        :height="subItem.full === undefined ? 173 : 250"
                        class="cursor-pointer">
                        <v-img 
                          v-if="subItem.value.length > 0"
                          contain
                          :width="subItem.full === undefined ? 173 : '100%'"
                          :height="subItem.full === undefined ? 173 : 250"
                          alt="vuetify"
                          :src="subItem.value">
                        </v-img>

                        <v-icon v-else size="50" color="grey">mdi-cloud-upload-outline</v-icon>
                      </v-avatar>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>

      <div v-if="message.error.length > 0"
        class="text-center my-4">
        <div
          class="error--text d-flex align-start">
          <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
          
          <span
            class="ml-1">
            {{ message.error }}
          </span>
        </div>
      </div>
    </v-card-text>

    <v-divider class="mx-4 mb-3 mt-0"/>

    <v-card-actions>
      <v-spacer/>

      <v-btn
        color="green"
        elevation="0"
        style="border-radius: 10px;"
        class="body-2 font-weight-bold text-capitalize white--text"
        :disabled="process.form || check.error.length > 0"
        :loading="process.form"
        v-on:keyup.enter="save()"
        @click="save()">
        <v-icon small class="mr-1">mdi-check-bold</v-icon>
        Simpan
      </v-btn>

      <v-btn
        outlined
        style="border-radius: 10px;"
        class="body-2 font-weight-bold text-capitalize red--text"
        :disabled="process.form"
        @click="reset()">
        <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
        Batal
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      },
      config: {
        type: Object,
        default: {}
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,

          form_position: false
        },

        show: false,
        images: null,

        form_position: {
          id: '',
          unit_id: '',
          par_id: '',
          title: '',
          job_desc: ''
        },

        list_unit: [],
        list_position: [],

        form: {},

        process: {
          form: false,
          image: false,

          form_position: false
        },
        check: {
          index: '',
          error: ''
        },
        message: {
          success: '',
          error: ''
        },

        select_title: '',
        select_sub: false
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    watch: {
      'images': {
        handler: function () {
          if (this.images) {
            this.process.image = this.images.process 

            if (!this.process.image) this.form.map(obj => { if (obj.type === 'image') obj.value = this.images.fileuri })
          }
        },
        deep: true
      }
    },
    mounted () {
      this.form = this.config.form
      
      this.form.map(obj => {
        if (obj.type === 'select_sub' && obj.value !== '') {
          let params = {
            id: obj.value
          }

          get('admin/indicator/data', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.select_title = res.results.data[0].name
            }
          })
        }
      })

      if (this.$route.name === 'Pegawai') this.fetchPosition()
    },
    methods: {
      async fetchCheck (val, index) {
        let params = {
          search: val
        }

        this.selected.row = []

        await get('admin/user', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let total = res.results.data.length

            this.check = {
              index: total > 0 ? index : '',
              error: total > 0 ? 'sudah digunakan' : ''
            }
          }
        })
      },

      selected (item) {
        this.form.map(obj => { 
          if (obj.relation === item.field) {
            let data = item.option.filter(function(v) {
              return item.value === v.value
            })

            if (data.length > 0) {
              obj.value = data[0].text
            }
          }

          if (obj.sub_select || obj.field === item.sub_select) {
            let params = {
              limit: 100000,
              unit_id: item.value
            }

            let array_option = []

            get(item.api, { params })
            .then(response => {
              let res = response.data
                
              if (res.status === 200) {
                if (obj.field === item.sub_select) {
                  obj.value = ''
                  
                  res.results.data.map(obj => {
                    array_option.push({
                      text: obj.title,
                      value: obj.id
                    })
                  })

                  obj.option = array_option
                }
              }
            })
          }
        })
      },
      
      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.$emit('close', false)

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let forms = {}

          this.form.map(obj => {
            if (obj.type === 'column') {
              obj.sub.map(obj_sub => {
                forms[obj_sub.field] = obj_sub.value
              })
            } else {
              forms[obj.field] = obj.value
            }
          })
          
          let url = forms.id.length < 1 ? this.config.action.add.api : this.config.action.edit.api

          // SAVE TO REST API
          await post(url, {
            data: forms
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.reset()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      reset_position () {
        if (this.$refs.form_position) this.$refs.form_position.reset()
        
        this.form_position.id = ''
        this.form_position.par_id = ''
        this.form_position.title = ''
        this.form_position.job_desc = ''

        this.process.form_position = false

        this.message.error = ''

        this.fetchUnit()
        this.fetchPosition()
      },

      async fetchUnit () {
        let params = {
          limit: 100000
        }

        this.list_unit = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list_unit.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },


      async fetchPosition () {
        let params = {
          limit: 100000
        }

        this.list_position = []

        await get('admin/user_position', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list_position.push({
                text: obj.title,
                value: obj.id
              })
            })
          }
        })
      },

      async save_position () {
        this.message.error = ''

        const isValid = await this.$refs.form_position.validate()

        if (isValid) {
          this.process.form_position = true

          console.log(this.form_position)

          // SAVE TO REST API
          await post('admin/user_position/add', {
            data: this.form_position
          })
          .then(response => {
            let res = response.data
            
            this.process.form_position = false

            if (res.status === 200) {
              this.dialog.form_position = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchPosition()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form_position.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form_position.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
    }
  }
</script>